import React, { FunctionComponent, type JSX } from "react";
import { TextInput } from "@narmi/design_system";
import { Tooltip } from "@narmi/design_system";

interface AccountNumberTextInputProps {
  onChange: (event: any) => void;
  value: string;
  error: string;
  label: string;
  maxLength: number;
  tooltipText: string;
}

const AccountNumberTextInput: FunctionComponent<AccountNumberTextInputProps> = ({
  onChange,
  value,
  error,
  label = "Account number",
  maxLength = 0,
  tooltipText = "",
}): JSX.Element => {
  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value.replace(/[^\d]/g, ""));
  };

  return (
    <TextInput
      id="account_number"
      label={label}
      field="account_number"
      onChange={handleInput}
      value={value}
      error={error}
      maxLength={maxLength}
      endContent={
        tooltipText && (
          <Tooltip text={tooltipText}>
            <span className="narmi-icon-info" />
          </Tooltip>
        )
      }
    />
  );
};

export default AccountNumberTextInput;
